import React from 'react'

import Pppmcalenderview from '../../components/ppmcalenderreportcomponents/Ppmcalenderview'

function  Ppmcalenderview({renderPageContent}) {
    return (
        <>
                        <Pppmcalenderview renderPageContent={renderPageContent}/>
        </>
    )
}

export default  Ppmcalenderview